import en from "./en";

export default {
  ...en,
  metaTitleBrand: "LOYA SPORT",
  metaTitleHome: "Início",
  metaTitleProducts: "Produtos",
  metaTitleProductDetail: "Detalhe do produto",
  metaTitleCustomService: "Serviço personalizado",
  metaTitleSolutions: "Soluções",
  metaTitleAbout: "Perfil da empresa",
  metaTitleContact: "Fale conosco",
  metaTitleBlog: "Blog",
  metaTitleLogin: "Entrar",
  metaTitleAdmin: "Painel administrativo",
  metaTitleSystemSetup: "Configuração do sistema",
  authLogin: {
    ...en.authLogin,
    welcomeBack: "Bem-vindo de volta",
    brandIntro: "Entre para continuar comprando produtos de yoga e fitness.",
    brandBullet1: "Fluxo RFQ ágil",
    brandBullet2: "Acompanhamento de produtos e pedidos",
    brandBullet3: "Suporte para contas B2B",
    accountLogin: "Entrar na conta",
    createAccount: "Criar conta",
    recoverPassword: "Recuperar senha",
    registrationComplete: "Cadastro concluído",
    passwordUpdated: "Senha atualizada",
    loginDesc: "Use seu nome de usuário ou e-mail e senha para continuar.",
    registerDesc: "Crie sua conta com nome de usuário, verificação por e-mail e proteção por captcha.",
    forgotDesc: "Digite o e-mail da sua conta para receber um código de redefinição e criar uma nova senha.",
    registerSuccessDesc: "Sua conta foi criada com sucesso. Voltaremos automaticamente para a tela de login.",
    resetSuccessDesc: "Sua senha foi atualizada com sucesso. Voltaremos automaticamente para a tela de login.",
    redirectHintPrefix: "A página voltará para o login em",
    redirectHintSuffix: ".",
    seconds: "segundos",
    loginNow: "Entrar agora",
    username: "Nome de usuário",
    usernamePlaceholder: "Pelo menos 3 caracteres, por exemplo loya_buyer",
    usernameHelp: "O nome de usuário deve ter pelo menos 3 caracteres, não pode usar palavras reservadas e só pode conter letras, números, sublinhado e hífen.",
    usernameExistsHint: "Este nome de usuário já está cadastrado. Faça login direto ou escolha outro.",
    usernameExists: "O nome de usuário já existe. Escolha outro ou entre diretamente.",
    usernameExistsAction: "Usuário já existe, ir para login",
    usernameAlreadyRegistered: "Este nome de usuário já está cadastrado.",
    usernameAvailable: "Nome de usuário disponível.",
    usernameVerifyFailed: "Não foi possível verificar o nome de usuário agora. Tente novamente.",
    checkingUsername: "Verificando disponibilidade do nome de usuário...",
    email: "E-mail",
    emailPlaceholder: "your@email.com",
    emailCodeTargetHint: "Digite o e-mail que você quer usar para receber o código de verificação.",
    emailExistsHint: "Este e-mail já está cadastrado. Faça login direto ou use outro e-mail.",
    emailExists: "O e-mail já existe. Use outro e-mail ou vá para o login.",
    emailExistsAction: "E-mail já existe, ir para login",
    emailAlreadyRegistered: "Este e-mail já está cadastrado.",
    emailAvailable: "E-mail disponível.",
    emailVerifyFailed: "Não foi possível verificar o e-mail agora. Tente novamente.",
    checkingEmail: "Verificando disponibilidade do e-mail...",
    usernameOrEmail: "Usuário ou e-mail",
    usernameOrEmailPlaceholder: "usuário ou your@email.com",
    forgotEmailHint: "Digite o e-mail vinculado à sua conta para enviarmos um código de redefinição.",
    password: "Senha",
    passwordPlaceholder: "Digite a senha",
    confirmPassword: "Confirmar senha",
    confirmPasswordPlaceholder: "Digite a senha novamente",
    confirmNewPassword: "Confirmar nova senha",
    confirmNewPasswordPlaceholder: "Digite a nova senha novamente",
    nickname: "Apelido",
    nicknamePlaceholder: "Opcional, usado para exibição",
    captcha: "Captcha",
    registerCaptcha: "Captcha de cadastro",
    resetCaptcha: "Captcha de redefinição",
    refreshCaptcha: "Atualizar captcha",
    load: "Carregar",
    forgotCaptchaHint: "Conclua primeiro o captcha e depois solicite o código de redefinição. Após o envio, um novo captcha será carregado automaticamente para a etapa final.",
    registerCaptchaHint: "Conclua primeiro o captcha e depois solicite o código de verificação por e-mail.",
    registerStepHint: "Preencha usuário, senha, confirmação e um e-mail válido primeiro. Depois a seção de captcha e código por e-mail aparecerá.",
    emailCode: "Código de e-mail",
    emailCodePlaceholder: "Código de 6 dígitos",
    resetCode: "Código de redefinição",
    resetCodePlaceholder: "Código de redefinição de 6 dígitos",
    sending: "Enviando...",
    resendIn: "Reenviar em",
    sendEmailCode: "Enviar código por e-mail",
    sendResetCode: "Enviar código de redefinição",
    signingIn: "Entrando...",
    login: "Entrar",
    updating: "Atualizando...",
    creating: "Criando...",
    resetPassword: "Redefinir senha",
    forgotRequirementHint: "A recuperação de senha exige a verificação por captcha e o código de redefinição enviado ao seu e-mail.",
    registerRequirementHint: "O cadastro exige o código enviado para sua caixa de entrada.",
    captchaRefreshHint: "Se o captcha estiver difícil de ler, clique na imagem à direita para atualizar.",
    switchToLogin: "Já tem conta? Entre agora",
    switchToRegister: "Ainda não tem conta? Cadastre-se agora",
    backToLogin: "Voltar ao login",
    forgotPassword: "Esqueceu a senha?",
    usernameRequired: "Digite um nome de usuário com pelo menos 3 caracteres.",
    usernameMin: "O nome de usuário deve ter pelo menos 3 caracteres.",
    usernameMax: "O nome de usuário deve ter no máximo 24 caracteres.",
    usernamePattern: "O nome de usuário só pode conter letras, números, sublinhados e hífens.",
    usernameReserved: "Este nome de usuário é reservado. Escolha outro.",
    usernameFormatOk: "Formato de nome de usuário válido.",
    emailRequired: "Digite um endereço de e-mail.",
    emailInvalid: "Digite um endereço de e-mail válido.",
    emailFormatOk: "Formato de e-mail válido.",
    emailProviderHint: "Use um provedor de e-mail comum quando possível, como Gmail, Outlook, QQ Mail, 163, 126 ou Foxmail.",
    didYouMean: "Você quis dizer",
    passwordMin: "A senha deve ter pelo menos 6 caracteres.",
    newPasswordMin: "A nova senha deve ter pelo menos 6 caracteres.",
    confirmPasswordRequired: "Digite a senha de confirmação.",
    passwordMatch: "As senhas coincidem.",
    passwordMismatch: "As duas senhas não coincidem.",
    emailCodeRequired: "Digite o código de verificação por e-mail.",
    resetCodeRequired: "Digite o código de redefinição enviado para o seu e-mail.",
    captchaRequired: "Digite o código captcha.",
    registerPrerequisitesError: "Preencha usuário, senha, confirmação e um e-mail válido antes de solicitar o código por e-mail.",
    enterCaptchaBeforeEmailCode: "Digite o captcha antes de solicitar o código de verificação por e-mail.",
    enterCaptchaBeforeResetCode: "Digite o captcha antes de solicitar o código de redefinição de senha.",
    sendEmailCodeFailed: "Falha ao enviar o código de verificação por e-mail. Tente novamente.",
    emailCodeSent: "O código de verificação por e-mail foi enviado.",
    registerFailed: "Falha no cadastro",
    resetFailed: "Falha na redefinição de senha",
    loginFailed: "Falha no login",
    registerSuccessNotice: "Cadastro concluído. Voltando para a tela de login em cerca de 4 segundos.",
    resetSuccessNotice: "Senha redefinida com sucesso. Voltando para a tela de login em cerca de 1,5 segundo.",
    loginTokenMissing: "Token de login ausente",
    profileLoadFailed: "Falha ao carregar o perfil da conta",
    loginSuccessAdmin: "Login realizado com sucesso. Redirecionando...",
    loginSuccessStorefront: "Login realizado com sucesso. Redirecionando para a loja...",
    loginServiceUnavailable: "O serviço de login está temporariamente indisponível. Tente novamente em instantes.",
    accountNotFound: "Conta não encontrada. Verifique seu nome de usuário ou e-mail.",
    passwordIncorrect: "Senha incorreta. Tente novamente.",
    registrationNotOpen: "O login e o cadastro estão fechados no momento.",
    accountRestricted: "Esta conta está restrita. Entre em contato com o administrador.",
    captchaExpired: "O captcha expirou. Atualize a página e tente novamente.",
    captchaIncorrect: "O código captcha está incorreto. Tente novamente.",
    passwordRequired: "Informe uma senha.",
    emailCodeSentInbox: "O código de verificação foi enviado. Verifique sua caixa de entrada.",
    previewCodeCurrentEnv: "Código de pré-visualização do ambiente atual",
    previewCodeDevelopment: "Código de pré-visualização para desenvolvimento",
    previewCodeGenerated: "O código de verificação foi gerado. Este ambiente usa um código de pré-visualização.",
    previewCodeContinueRegistration: "Informe este código de 6 dígitos para continuar o cadastro.",
    tooManyRequests: "Muitas solicitações. Tente novamente mais tarde.",
    smtpConfigRetry: "Não foi possível enviar o e-mail. Verifique as configurações SMTP e tente novamente.",
    emailServiceNotConfigured: "O serviço de e-mail não está configurado. Entre em contato com o administrador.",
    requestFailed: "A solicitação falhou. Tente novamente ou entre em contato com o suporte.",
    orContinueWith: "Ou continuar com",
    googleAuthorizing: "Autorizando conta Google...",
    googleFallbackAction: "Continuar com Google",
    googleAuthFailed: "A autenticação com Google falhou",
    googleAuthOffline: "O login com Google não está disponível offline. Conecte-se à internet ou use usuário e senha.",
    googleAuthTimeout: "A verificação do Google expirou. Tente novamente. Se o problema persistir, peça ao administrador para verificar o acesso de rede do servidor.",
    googleAuthNetworkError: "A verificação do Google falhou devido a um erro de rede no servidor. Entre em contato com o administrador.",
    googleRegisterSuccess: "Conta Google vinculada com sucesso. Redirecionando para a loja...",
    googleCreateAccountTitle: "Conclua seu cadastro com Google",
    googleCreateAccountDesc: "O Google verificou seu e-mail. Defina uma senha para criar sua conta de cliente e concluir o login.",
    googleCreateAccountHint: "Não existe conta para este e-mail do Google. Defina uma senha para criar sua conta de cliente.",
    googleLinkedEmailHint: "Este e-mail verificado pelo Google será usado para criar sua conta de cliente.",
    googleCreatePasswordHint: "Defina e confirme uma senha. A nova conta de cliente usará seu e-mail verificado pelo Google."
  },

  // --- storefront ---
  navHome: "Início",
  navProducts: "Produtos",
  navCustomization: "Serviço personalizado",
  navSolutions: "Soluções",
  navAbout: "Perfil da empresa",
  navContact: "Fale conosco",

  navYogaMats: "Tapetes de yoga",
  navYogaBlocks: "Blocos de yoga",
  navYogaStraps: "Alças de yoga",
  navResistanceBands: "Faixas de resistência",
  navPilatesRings: "Anéis de pilates",
  navFoamRollers: "Rolos de espuma",
  navOemPrivateLabel: "Serviço personalizado",
  navSolutionsControl: "Controle de qualidade",
  navCompanyProfile: "Perfil da empresa",
  navContactUs: "Fale conosco",
  navBlog: "Blog",

  btnContactUs: "Fale conosco",
  btnLogin: "Entrar",
  btnAccount: "Conta",
  btnQuote: "Solicitar cotação",
  btnCurrency: "Moeda",
  btnLanguage: "Idioma",

  seeAllCategories: "Ver todas as categorias",
  productDetailReady: "Pronto para marca própria",
  productDetailQuote: "Cotação sob consulta",
  productDetailViewSpecs: "Ver especificações",
  productDetailRequestQuote: "Solicitar cotação",
  pdLoadErrorProductDetail: "Falha ao carregar os detalhes do produto",
  pdLoadErrorRelatedProducts: "Falha ao carregar produtos relacionados",
  pdLoadErrorStorefrontConfig: "Falha ao carregar a configuração da vitrine",
  pdLoading: "Carregando detalhes do produto...",
  pdSampleDefaultMessage: "Compartilhe a política de amostras, prazo e detalhes da cotação.",
  pdAttrProductName: "Nome do produto",
  pdAttrModelNo: "Modelo",
  pdAttrCategory: "Categoria",
  pdAttrManufacturer: "Fabricante",
  pdLeadTimeOnRequest: "Prazo sob consulta",
  pdLeadTimeUpTo: "Até {qty} peças: {days} dias",
  pdLeadTimeFrom: "{qty}+ peças: {days} dias",
  pdLeadTimeDaysOnly: "{days} dias",
  pdContactForQuote: "Entre em contato para cotação",
  pdPerPiece: "{price} / peça",
  pdAnonymousBuyer: "Comprador anônimo",
  pdReviewTipSignIn: "Faça login como cliente para marcar como útil.",
  pdReviewTipSessionExpired: "Sessão expirada. Faça login novamente.",
  pdReviewTipNoPermission: "A conta atual não pode marcar como útil.",
  pdReviewTipUpdateFailed: "Falha ao atualizar estado de útil",
  pdSpecValues: "Valores",
  pdSpecRequired: "Obrigatório",
  pdSpecOptional: "Opcional",
  pdCapabilityCustomLogo: "Aplicação de logotipo personalizado",
  pdCapabilitySampleDev: "Desenvolvimento baseado em amostra",
  pdCapabilityPackagingCoordination: "Coordenação de embalagem",
  pdCapabilityExportFollowUp: "Acompanhamento de embarque de exportação",
  pdPackagingSellingUnit: "Unidade de venda",
  pdPackagingSingleItem: "Item único",
  pdPackagingType: "Embalagem",
  pdPackagingTypeFallback: "Saco OPP / caixa de exportação",
  pdPackagingLoadingAdvice: "Orientação de carregamento",
  pdPackagingLoadingAdviceFallback: "Com base na estrutura do pedido",
  pdPackagingLeadTime: "Prazo",
  pdMediaPhotoLabel: "Foto {index}",
  pdMediaVideoLabel: "Vídeo",
  pdMediaAttributesLabel: "Atributos",
  pdPackagingPointPackaging: "Embalagem: {value}",
  pdPackagingPointLoadingAdvice: "Orientação de carregamento: {value}",
  pdPackagingPointShippingPort: "Porto de embarque: {value} (negociável)",
  pdPackagingPointShippingPortNegotiable: "Porto de embarque: negociável",
  pdPackagingPointLeadTime: "Prazo: {value}",
  pdInquiryHello: "Olá, quero consultar sobre:",
  pdInquiryProduct: "Produto: {value}",
  pdInquirySku: "SKU: {value}",
  pdInquirySkuName: "Nome do SKU: {value}",
  pdInquiryModel: "Modelo: {value}",
  pdInquiryQuantity: "Quantidade: {value}",
  pdEmailSubject: "Consulta: {sku} - {name}",
  pdInquirySubmitFailed: "Não foi possível enviar a consulta agora.",
  pdSampleContactPerson: "Contato: {value}",
  pdSampleWhatsapp: "WhatsApp/WeChat: {value}",
  pdSampleCompany: "Empresa: {value}",
  pdSampleRequestedQuantity: "Quantidade solicitada: {value}",
  pdSampleSelectorQuantity: "Seletor de quantidade da página: {value}",
  pdVariationLabel: "Opção",
  pdVariationInquiryIntro: "Olá, gostaria de enviar uma consulta para:",
  pdVariationInquiryQuoteLeadTime: "Compartilhe a cotação mais recente e o prazo.",
  pdVideoFallback: "Falha ao carregar vídeo. Tente novamente ou abra a origem.",
  pdRetry: "Tentar novamente",
  pdOpenVideoUrl: "Abrir URL do vídeo",
  pdProductAttributes: "Atributos do produto",
  pdMediaTabsAria: "Tipos de mídia do produto",
  pdMediaTabPhotos: "Fotos",
  pdMediaTabVideo: "Vídeo",
  pdMediaTabAttributes: "Atributos",
  pdInfoTabsAria: "Abas de informação de detalhes",
  pdInfoTabAttributes: "Atributos",
  pdInfoTabDescription: "Descrição",
  pdInfoTabSupplier: "Fornecedor",
  pdInfoTabReviews: "Avaliações",
  pdKeyAttributes: "Atributos-chave",
  pdPackagingShippingInfo: "Informações de embalagem e envio",
  pdProductDescription: "Descrição do produto",
  pdSupplierOverview: "Visão geral do fornecedor",
  pdSupplierOverviewHint: "Perfil da empresa e FAQ são exibidos abaixo das imagens de detalhe.",
  pdBuyerFeedback: "Feedback de compradores",
  pdRepeatBuyer: "Comprador recorrente",
  pdReviewRatingAria: "Avaliação {rating} de 5",
  pdReviewMetaColor: "cor: {value}",
  pdReviewMetaColorFallback: "segundo",
  pdReviewUnavailable: "Este produto não está mais disponível",
  pdReviewHelpful: "Útil ({count})",
  pdNoReviews: "Ainda não há avaliações para este produto.",
  pdNoReviewsHint: "Fale com nossa equipe para referências de pedidos ou feedback de amostras.",
  pdTitleFallback: "Detalhe do produto",
  pdCustomizable: "Personalizável",
  pdVariationCardAria: "Variações do produto",
  pdVariations: "Variações",
  pdSelectNow: "Selecionar agora",
  pdSelectOption: "Selecionar opção",
  pdLadderPricingAria: "Preço escalonado",
  pdProductSpecifications: "Especificações do produto",
  pdSpecPrevAria: "Mostrar valor de especificação anterior",
  pdSpecNextAria: "Mostrar próximo valor de especificação",
  pdSupplierCapability: "Capacidade de personalização do fornecedor",
  pdGetFreeSample: "Obter amostra grátis",
  pdWhatsAppInquiry: "Consulta por WhatsApp",
  pdEmailInquiry: "Consulta por e-mail",
  pdPackagingDelivery: "Embalagem e entrega",
  pdProductVideo: "Vídeo do produto",
  pdVideoOpenLink: "O vídeo não pode ser reproduzido no contexto atual.",
  pdSupplierDescriptions: "Descrições do produto do fornecedor",
  pdCompanyIntroduction: "Introdução da empresa",
  pdNoCompanyIntroduction: "Nenhuma introdução da empresa configurada.",
  pdFaq: "FAQ",
  pdNoFaq: "Nenhuma FAQ configurada.",
  pdCloseVariationSelector: "Fechar seletor de variação",
  pdVariationSelectAndQty: "Selecionar variações e quantidade",
  pdVariationStock: " / estoque {count}",
  pdSelectedQuantity: "Quantidade selecionada",
  pdSendInquiry: "Enviar consulta",
  pdChatNow: "Conversar agora",
  pdOptionLabel: "Opção {index}",
  pdRelatedAria: "Produtos relacionados",
  pdRelatedTitle: "Produtos relacionados",
  pdRelatedSubtitle: "Mais itens que os compradores costumam adquirir juntos nesta categoria.",
  pdRelatedPrevAria: "Produtos relacionados anteriores",
  pdRelatedNextAria: "Próximos produtos relacionados",
  pdSampleContactTitle: "Entre em contato",
  pdSampleContactDesc: "Tem dúvidas? Ficaremos felizes em ajudar. Fale conosco via WhatsApp ou e-mail para suporte de amostras.",
  pdSampleCloseAria: "Fechar consulta de amostra",
  pdSampleSummaryProduct: "Produto",
  pdSampleSummaryQuantity: "Quantidade",
  pdFormFullName: "Nome completo",
  pdFormFullNamePlaceholder: "Seu nome",
  pdFormEmail: "E-mail*",
  pdFormEmailPlaceholder: "Contato por e-mail",
  pdFormWhatsapp: "WhatsApp/WeChat*",
  pdFormWhatsappPlaceholder: "Contato por WhatsApp",
  pdFormCompany: "Nome da sua empresa",
  pdFormCompanyPlaceholder: "Nome da sua empresa",
  pdFormRequiredQuantity: "Quantidade necessária",
  pdFormRequiredQuantityPlaceholder: "Quantidade necessária para amostra ou teste",
  pdFormMessage: "Mensagem",
  pdFormMessagePlaceholder: "Descreva brevemente os requisitos do seu produto",
  pdFormSending: "Enviando...",
  pdFormSendMessage: "Enviar mensagem",
  pdFormInquirySuccess: "Consulta enviada com sucesso.",

  carouselLoadingTitle: "Carregando imagens do banner",
  carouselLoadingBody:
    "Estamos preparando os visuais da página inicial para você. Aguarde um momento enquanto as imagens do banner são carregadas.",
  carouselPlaceholderTitle: "As imagens do banner estão sendo preparadas",
  carouselPlaceholderBody:
    "O carrossel da página inicial aparecerá aqui assim que os recursos de imagem estiverem prontos.",

  // --- OEM / custom service ---
  oemHeroKicker: "Serviço personalizado",
  oemTitle:
    "Crie uma linha de yoga personalizada com um fluxo de produção claro",
  oemIntro:
    "Apoiamos compradores internacionais com personalização de produtos, desenvolvimento de embalagens, acompanhamento de amostras e execução de pedidos para as categorias de yoga e fitness leve.",
  oemStartProject: "Inicie seu projeto personalizado",
  oemBrowseProducts: "Ver produtos base",
  oemVisualGuide: "Guia visual de personalização",
  oemVisualAlt: "Guia do processo e das opções de personalização OEM",
  oemVisualPlaceholder:
    "Imagem de personalização não encontrada. Adicione seu arquivo em frontend/public/assets/about/oem-customization-guide.jpg",
  oemCapabilityKicker: "O que podemos personalizar",
  oemCapabilityTitle:
    "Da aplicação do logotipo à execução completa da embalagem",
  oemProjectBrief: "Resumo do projeto",

  oemCapability1:
    "Impressão personalizada de logotipo, gravação em relevo e marcação a laser para os principais acessórios de yoga.",
  oemCapability2:
    "Ajustes de cor, material, textura e tamanho alinhados ao seu mercado-alvo.",
  oemCapability3:
    "Embalagens prontas para varejo, cartões internos, etiquetas de código de barras e marcações de caixa.",
  oemCapability4:
    "Desenvolvimento de kits para estúdios, pacotes prontos para Amazon e promoções sazonais.",

  oemProcess1Title: "Compartilhe sua ideia",
  oemProcess1Body:
    "Envie os produtos desejados, arquivos de logotipo, imagens de referência, expectativas de embalagem e quantidade estimada.",
  oemProcess2Title: "Confirmar especificações e MOQ",
  oemProcess2Body:
    "Analisamos opções de material, método de personalização, pontos de conformidade, prazo de entrega e quantidade inicial viável.",
  oemProcess3Title: "Amostras e revisão",
  oemProcess3Body:
    "Organizamos amostras ou mockups, coletamos seu feedback e definimos o padrão de produção antes do depósito.",
  oemProcess4Title: "Produção em massa e inspeção",
  oemProcess4Body:
    "A produção segue a amostra aprovada, com verificação da embalagem e revisão de qualidade antes do embarque.",

  // --- news ---
  newsHeroKicker: "Atualizações do setor",
  newsTitle: "Notícias e atualizações",
  newsIntro:
    "Acompanhe nossos insights mais recentes de sourcing, notas de lançamento de produtos e atualizações de exportação para compradores de acessórios fitness.",
  newsSectionTitle:
    "Para anúncios de projetos personalizados ou prévias de novas coleções, entre em contato com nossa equipe comercial para obter o catálogo mais recente.",

  news1Title: "Guia de sourcing de primavera lançado",
  news1Body:
    "Explore as últimas tendências em yoga, pilates e produtos de recuperação para a próxima temporada de varejo.",
  news2Title: "Atualizações de embalagem OEM",
  news2Body:
    "Agora oferecemos mais opções ecológicas de caixas, cartões internos e embalagens com código de barras para programas de marca própria.",
  news3Title: "Aviso sobre cronograma de exportação",
  news3Body:
    "Os prazos de produção e janelas de embarque são atualizados semanalmente para ajudar compradores a gerenciar melhor seus calendários de lançamento.",

  // --- contact ---
  contactHeroKicker: "Consulta comercial",
  contactTitle: "Contato com fornecedor",
  contactIntro:
    "Informe seus requisitos de produto e mercado-alvo. Nossa equipe responderá com cotação e estimativa de prazo.",
  contactFormTitle: "Enviar consulta",
  contactName: "Seu nome",
  contactEmail: "E-mail corporativo",
  contactCompany: "Nome da empresa",
  contactMessage: "Especificações do produto, quantidade e destino de envio",
  contactSubmit: "Enviar consulta",
  contactSent: "Mensagem enviada com sucesso.",

  contactInfoTitle: "Escritório comercial",
  contactInfoEmail: "E-mail",
  contactInfoPhone: "Telefone",
  contactInfoHours: "Horário: Seg-Sáb, 09:00-18:00 (GMT+8)",
  contactInfoNote:
    "Canal recomendado: e-mail para cotação formal e telefone para urgências de cronograma.",

  contactResponseTitle: "Tempo médio de resposta",
  contactResponseDesc: "Até 8 horas úteis para RFQ padrão.",
  contactDocsTitle: "Documentos disponíveis",
  contactDocsDesc:
    "Fatura comercial, romaneio e suporte de coordenação logística.",
  contactSampleTitle: "Serviço de amostras",
  contactSampleDesc:
    "Amostragem rápida para projetos OEM e marca própria.",

  // --- about ---
  aboutTitle: "Sobre a LOYA SPORT",
  aboutIntro:
    "A LOYA SPORT é uma integradora de cadeia de suprimentos de produtos de yoga para compradores B2B globais.",
  aboutWhoWeAre: "Quem somos",
  aboutWhoWeAreDesc1:
    "Apoiamos importadores, distribuidores, varejistas e marcas próprias coordenando sourcing, amostras, branding e acompanhamento de embarques com parceiros de fornecimento verificados.",
  aboutWhoWeAreDesc2:
    "Nossa força está na comunicação prática, no foco por categoria e em um fluxo de compra claro que ajuda clientes internacionais a avançar com mais rapidez.",

  aboutSupplyCapabilities: "Capacidades de fornecimento",
  aboutSupplyList1:
    "Coordenação com fornecedores verificados para linhas de yoga e fitness leve",
  aboutSupplyList2:
    "Revisão de qualidade em várias etapas com fábricas parceiras",
  aboutSupplyList3: "Suporte para marca própria e embalagem",
  aboutSupplyList4: "Suporte de fornecimento para mercados globais",

  aboutProductDev: "Desenvolvimento de produto",
  aboutProductDevDesc:
    "Ciclos rápidos de amostras e colaboração prática em design para acelerar o lançamento no mercado.",
  aboutSupplyReliability: "Confiabilidade do fornecimento",
  aboutSupplyReliabilityDesc:
    "Abastecimento estável de materiais e planejamento de capacidade para manter as entregas em dia nas temporadas de pico.",
  aboutTradeSupport: "Suporte comercial",
  aboutTradeSupportDesc:
    "Documentação, coordenação de embarque e suporte pós-venda para operações internacionais mais tranquilas.",

  aboutMission: "Nossa missão",
  aboutMissionDesc:
    "Ajudar marcas fitness e compradores do varejo a crescer por meio de sourcing confiável, controle de qualidade rigoroso e suporte completo de pós-venda.",

  searchOverlayPlaceholder: "Buscar produtos por nome...",
  searchOverlaySubmitAria: "Enviar busca",
  searchOverlaySubmitTitle: "Buscar",
  searchOverlayHintPrefix: "Pressione",
  searchOverlayHintSuffix:
    "para ver todos os produtos correspondentes, ou escolha um resultado rápido abaixo.",
  searchOverlayCloseAria: "Fechar busca",
  searchOverlayQuickResults: "Resultados rápidos",
  searchOverlayQuickResultsAria: "Resultados rápidos de busca",
  searchOverlayFallbackCategory: "Acessórios de yoga",
  searchOverlayHistory: "Histórico de busca",
  searchOverlayClear: "Limpar",
  searchOverlayNoHistory: "Sem buscas recentes",
  searchOverlayRecommended: "Palavras-chave recomendadas",
  searchOverlayFallbackKeyword: "Tapete de yoga",

  blogHeroKicker: "Central de conteúdo",
  blogHeroTitle: "Insights e guias de compra",
  blogSearchAria: "Buscar artigos",
  blogCategoryAria: "Categorias de artigos",
  blogFeaturedPlaceholder: "Insight em destaque",
  blogPaginationAria: "Paginação do blog",
  blogCtaAria: "Chamada para ação do blog",
  blogCtaDescription: "Nossa equipe pode oferecer recomendações direcionadas e acompanhar desde amostras até entrega em volume.",
  blogCtaPrimary: "Falar agora",
  blogCtaSecondary: "Ver soluções",
  contactInquiryGreeting: "Olá, gostaria de consultar este produto:",
  contactInquiryProductPrefix: "Produto:",
  contactInquiryQuantity: "Quantidade:",
  contactInquiryDestinationPort: "Porto de destino:",

  aboutHeroKicker: "Integrador de cadeia de suprimentos",
  aboutHeroTitle:
    "Ajudamos compradores internacionais a gerenciar sourcing, coordenação de fábrica e entrega de exportação com uma única equipe comercial.",
  aboutHeroBody:
    "A LOYA SPORT se posiciona como integradora da cadeia de suprimentos para yoga, pilates e fitness leve. Não apenas apresentamos produtos. Organizamos fornecedores, amostras, embalagem, acompanhamento de qualidade e preparação de embarque em um fluxo de compra viável para clientes internacionais.",
  aboutMetric1:
    "janela única de projeto para comunicação de produto, embalagem e entrega",
  aboutMetric2:
    "recursos de fábrica coordenados sob uma única estrutura de sourcing e acompanhamento",
  aboutMetric3:
    "fluxo B2B construído para importadores, varejistas, distribuidores e compradores de marca própria",
  aboutPlaceholderNote:
    "Nosso papel é reduzir a comunicação fragmentada entre comprador, fornecedor e equipes de execução da fábrica, para que os projetos avancem com mais clareza e menos pontos cegos.",
  aboutHeroImageAlt:
    "Reunião de coordenação de cadeia de suprimentos para compradores de exportação",
  aboutHeroCaption:
    "Da consulta ao embarque, coordenamos os detalhes que normalmente ficam divididos entre agentes de sourcing, fábricas e contatos de logística.",
  aboutOfficeImageAlt: "Prédio de escritórios da Loya Technology em Changsha",
  aboutOfficeCaption: "Escritório da Loya Technology em Changsha",
  aboutTeamImageAlt: "Nossa equipe profissional no escritório de Changsha",
  aboutFactoryImageAlt: "Linha de produção de tapetes de yoga e fluxo de qualidade",
  aboutFactoryCollageAlt: "Armazém da fábrica e detalhes de produção",
  aboutWhatWeDoTitle: "O que realmente fazemos",
  aboutWhatWeDoBody1:
    "Muitos compradores não precisam apenas de um catálogo. Precisam de um parceiro que conecte requisitos comerciais com execução real de fábrica. É aí que atuamos. Coordenamos seleção de fornecedores, discussão de preços, amostras de produto, execução de embalagem, acompanhamento de produção, alinhamento de inspeção e prontidão de exportação.",
  aboutWhatWeDoBody2:
    "Em vez de deixar detalhes de produto, arquivos de embalagem, timing de entrega e mudanças de pedido em contatos separados, centralizamos o processo e mantemos o projeto avançando por um único caminho de comunicação responsável.",
  aboutBadge1: "Matching de fornecedores",
  aboutBadge2: "Acompanhamento de amostras",
  aboutBadge3: "Execução de embalagem",
  aboutBadge4: "Prontidão de embarque",
  aboutSideImageAlt: "Comunicação com comprador e revisão de projeto",
  aboutIntegratedCapabilitiesTitle:
    "Capacidades integradas de suprimentos",
  aboutSideCaption:
    "Nos concentramos em tornar a cadeia de sourcing mais fácil de gerir para compradores internacionais que precisam de coordenação confiável, e não de atividades comerciais isoladas.",
  aboutCapabilityCard1Title: "Integração da rede de fornecedores",
  aboutCapabilityCard1Body:
    "Combinamos recursos de fábrica, conhecimento de categoria e controles de sourcing em um fluxo único orientado ao comprador para que você não precise coordenar múltiplas partes sozinho.",
  aboutCapabilityCard2Title: "Coordenação comercial e técnica",
  aboutCapabilityCard2Body:
    "De cotação, amostragem e detalhes de embalagem até confirmação de especificações e checkpoints de produção, mantemos o lado comercial e o lado fábrica alinhados.",
  aboutCapabilityCard3Title: "Execução de pedidos de exportação",
  aboutCapabilityCard3Body:
    "Acompanhamos os pedidos por inspeção, documentação, booking e prontidão de embarque para reduzir lacunas de comunicação e risco de entrega.",
  aboutOperatingModel1:
    "Sourcing por categoria e matching de fábrica com base no seu mercado-alvo e faixa de preço.",
  aboutOperatingModel2:
    "Amostragem, revisão de especificações e coordenação de embalagem antes de travar a produção.",
  aboutOperatingModel3:
    "Acompanhamento de produção, checkpoints de qualidade e preparação de embarque sob um único fluxo de projeto.",
  aboutOperatingModel4:
    "Janela única de comunicação para produto, embalagem, documentação e progresso de entrega.",
  aboutWhoWeServeTitle: "Quem atendemos",
  aboutBuyerScenario1Title: "Para importadores e distribuidores",
  aboutBuyerScenario1Body:
    "Ajudamos a consolidar linhas de produto, comparar opções de fornecedores e construir um plano de reposição mais estável entre categorias.",
  aboutBuyerScenario2Title: "Para redes varejistas e vendedores e-commerce",
  aboutBuyerScenario2Body:
    "Apoiamos sortimentos prontos para lançamento, embalagem de marca própria e comunicação prática para pedidos repetíveis.",
  aboutBuyerScenario3Title: "Para marcas expandindo linhas de produto",
  aboutBuyerScenario3Body:
    "Atuamos como camada de coordenação entre seu conceito, o lado de produção e a execução de exportação para que equipes internas avancem mais rápido.",
  aboutWorkflowTitle: "Como estruturamos o fluxo",
  aboutWorkflowStep1:
    "Recebimento de requisitos e clarificação do produto-alvo",
  aboutWorkflowStep2:
    "Matching de fornecedores, cotação e planejamento de amostras",
  aboutWorkflowStep3:
    "Revisão de especificações, embalagem e conformidade",
  aboutWorkflowStep4:
    "Acompanhamento de produção, inspeção e prontidão de embarque",
  aboutWhyIntegratorTitle:
    "Por que compradores usam um integrador de cadeia",
  aboutWhyIntegratorBody1:
    "Quando o sourcing cruza múltiplos fornecedores, parceiros de embalagem e cronogramas de embarque, o maior risco geralmente não é a primeira cotação. É a perda de alinhamento depois que o pedido começa a andar.",
  aboutWhyIntegratorList1:
    "As especificações podem desviar entre cotação e produção.",
  aboutWhyIntegratorList2:
    "Detalhes de embalagem e branding podem atrasar por comunicação fragmentada.",
  aboutWhyIntegratorList3:
    "Inspeção, documentação e preparação de embarque podem se desconectar da promessa comercial original.",
  aboutWhyIntegratorBody2:
    "Nosso valor é manter essas partes conectadas. Trabalhamos como camada de coordenação entre expectativas do comprador e execução do fornecedor para que decisões fiquem documentadas, prazos sejam acompanhados e risco de handoff seja reduzido.",
  aboutTalkToTeam: "Falar com nossa equipe",
  aboutPositioningTitle: "Nosso posicionamento",
  aboutPositioningBody:
    "A LOYA SPORT se posiciona como integradora de cadeia para produtos fitness orientados à exportação. Ajudamos clientes a comprar com coordenação mais clara, organização de fornecedores mais forte e um caminho mais gerenciável do sourcing ao embarque.",

  solutionsHeroKicker: "Soluções",
  solutionsHeroTitle:
    "Escolha a rota de sourcing certa para o seu tipo de comprador",
  solutionsHeroBody:
    "Construído como guia visual para ajuste de canal, cenário e planejamento de programa de produto.",
  solutionsTalkToSales: "Falar com vendas",
  solutionsBrowseProducts: "Ver produtos",
  solutionsHeroImageAlt:
    "Soluções de sourcing B2B para compradores de yoga e fitness leve",
  solutionsHeroBadgeTitle: "Ajuste da solução",
  solutionsHeroBadgeBody: "Tipo de comprador + caso de uso + sortimento",
  solutionsBuyerTypeTitle: "Soluções por tipo de comprador",
  solutionsViewMatchingProducts: "Ver produtos compatíveis",
  solutionsScenarioPlansTitle: "Planos por cenário",
  solutionsProgramMixesTitle: "Mixes de programa recomendados",
  solutionsNextStepKicker: "Próximo passo",
  solutionsNextStepTitle:
    "Precisa de um mix sob medida para seu mercado?",
  solutionsNextStepBody:
    "Compartilhe seu tipo de comprador, produtos-alvo e mercado de destino. Vamos sugerir uma rota de sortimento prática.",
  solutionsRequestPlan: "Solicitar plano de solução",
  solutionsExploreOem: "Explorar suporte OEM",

  solutionsBuyerCard1Title: "Atacadistas",
  solutionsBuyerCard1Subtitle:
    "Construção rápida de sortimento para programas em volume.",
  solutionsBuyerCard1Need1:
    "Precisa de fornecimento estável em volume com menos risco de ruptura",
  solutionsBuyerCard1Need2:
    "Precisa de mix SKU pronto por caixa para acelerar revenda",
  solutionsBuyerCard1Need3:
    "Precisa de ciclos de recompra com lead time previsível",
  solutionsBuyerCard1Tag1: "Sortimentos em volume",
  solutionsBuyerCard1Tag2: "Packs prontos por caixa",
  solutionsBuyerCard1Tag3: "Reposição recorrente",

  solutionsBuyerCard2Title: "Varejistas",
  solutionsBuyerCard2Subtitle:
    "Packs prontos para prateleira e reposição estável.",
  solutionsBuyerCard2Need1:
    "Precisa de escadas de preço claras do nível básico ao premium",
  solutionsBuyerCard2Need2:
    "Precisa de embalagem com código de barras para listar mais rápido",
  solutionsBuyerCard2Need3:
    "Precisa de reposição confiável para itens de alto giro",
  solutionsBuyerCard2Tag1: "Packs de varejo",
  solutionsBuyerCard2Tag2: "Suporte a código de barras",
  solutionsBuyerCard2Tag3: "Mix pronto para exposição",

  solutionsBuyerCard3Title: "Marcas fitness",
  solutionsBuyerCard3Subtitle:
    "Programas de marca própria para expansão de marca.",
  solutionsBuyerCard3Need1:
    "Precisa de branding personalizado sem reconstruir toda a cadeia",
  solutionsBuyerCard3Need2:
    "Precisa de estilos de embalagem alinhados ao posicionamento da marca",
  solutionsBuyerCard3Need3:
    "Precisa reduzir o tempo de amostra até lançamento",
  solutionsBuyerCard3Tag1: "Aplicação de logo",
  solutionsBuyerCard3Tag2: "Embalagem customizada",
  solutionsBuyerCard3Tag3: "Extensão de linha",

  solutionsBuyerCard4Title: "Estúdios de yoga",
  solutionsBuyerCard4Subtitle:
    "Kits de estudio, acessorios e combinacoes para aula.",
  solutionsBuyerCard4Need1:
    "Precisa de kits iniciais para novos membros e aulas de teste",
  solutionsBuyerCard4Need2:
    "Precisa de acessórios duráveis para sessões de alta frequência",
  solutionsBuyerCard4Need3:
    "Precisa de precificacao pratica de combinacao para upsell",
  solutionsBuyerCard4Tag1: "Kits iniciais",
  solutionsBuyerCard4Tag2: "Acessórios de aula",
  solutionsBuyerCard4Tag3: "Kits de upgrade de membros",

  solutionsBuyerCard5Title: "Vendedores Amazon",
  solutionsBuyerCard5Subtitle:
    "Combinacoes e embalagem prontas para marketplace.",
  solutionsBuyerCard5Need1:
    "Precisa de estrutura compacta de combinacao para controlar frete",
  solutionsBuyerCard5Need2:
    "Precisa de combinações de produto orientadas à conversão",
  solutionsBuyerCard5Need3:
    "Precisa de qualidade de embalagem que reduza devoluções",
  solutionsBuyerCard5Tag1: "Combinacoes compactas",
  solutionsBuyerCard5Tag2: "Embalagem pronta para listing",
  solutionsBuyerCard5Tag3: "Lançamentos sem atrito",

  solutionsBuyerCard6Title: "Negócios de e-commerce",
  solutionsBuyerCard6Subtitle:
    "Produtos visual-first para vendas online recorrentes.",
  solutionsBuyerCard6Need1:
    "Precisa de SKUs hero com bom desempenho em anúncios e redes sociais",
  solutionsBuyerCard6Need2:
    "Precisa de combinacoes flexiveis para elevar o AOV",
  solutionsBuyerCard6Need3:
    "Precisa de refresh rápido de catálogo para campanhas sazonais",
  solutionsBuyerCard6Tag1: "Produtos hero",
  solutionsBuyerCard6Tag2: "Logica de combinacao",
  solutionsBuyerCard6Tag3: "Refresh rápido de catálogo",

  solutionsScenario1Title: "Kits iniciais para estúdio",
  solutionsScenario1Body:
    "Combinacoes de yoga prontas para lancamento em aulas, testes e planos de membros.",
  solutionsScenario2Title: "Áreas de recuperação e massagem",
  solutionsScenario2Body:
    "Ferramentas de massagem, rolos e acessórios de recuperação para cantos de academia.",
  solutionsScenario3Title: "Programas de exposição no varejo",
  solutionsScenario3Body:
    "Sortimentos equilibrados com embalagem adequada para exposição em prateleira.",
  solutionsScenario4Title: "Ofertas de combinacao online",
  solutionsScenario4Body:
    "Kits compactos desenhados para páginas de produto focadas em conversão.",

  solutionsProgram1Title: "Mix de lançamento para estúdio",
  solutionsProgram1Body:
    "Um sortimento inicial limpo para negócios de yoga baseados em aula.",
  solutionsProgram1Item1: "Tapetes de yoga",
  solutionsProgram1Item2: "Blocos e alças",
  solutionsProgram1Item3: "Acessórios de massagem",
  solutionsProgram1SuitedFor: "Estúdios / treinadores",

  solutionsProgram2Title: "Programa de prateleira varejo",
  solutionsProgram2Body:
    "Família de produtos equilibrada para lojas que precisam de escadas de preço claras e pedidos recorrentes.",
  solutionsProgram2Item1: "Tapetes principais",
  solutionsProgram2Item2: "Acessórios de pilates",
  solutionsProgram2Item3: "Ferramentas de recuperação por impulso",
  solutionsProgram2SuitedFor: "Varejistas / distribuidores",

  solutionsProgram3Title: "Pacote de combinacao online",
  solutionsProgram3Body:
    "Sets compactos construídos para visual de PDP e conversão online mais fácil.",
  solutionsProgram3Item1: "Mini kits",
  solutionsProgram3Item2: "Packs para presente",
  solutionsProgram3Item3: "Insertos de marca própria",
  solutionsProgram3SuitedFor: "Amazon / e-commerce",

  admin: {
    ...(en.admin || {}),

    // --- categories / faq / company images ---
    productCategoryYogaMats: "Tapetes de yoga",
    productCategoryYogaBlocks: "Blocos de yoga",
    productCategoryYogaStraps: "Alças de yoga",
    productCategoryResistanceBands: "Faixas de resistência",
    productCategoryPilatesRings: "Anéis de pilates",
    productCategoryFoamRollers: "Rolos de espuma",
    productCategoryOthers: "Outros",

    faqSampleOrderQ: "Vocês aceitam pedidos de amostra?",
    faqSampleOrderA:
      "Sim, aceitamos pedidos de amostra. Fique à vontade para entrar em contato conosco.",
    faqCustomPackagingQ:
      "Vocês oferecem embalagem personalizada e serviço de logotipo?",
    faqCustomPackagingA:
      "Sim, oferecemos serviços personalizados de OEM/ODM.",
    faqLeadTimeQ: "Qual é o prazo de entrega?",
    faqLeadTimeA:
      "Normalmente de 1 a 3 dias, dependendo da quantidade do pedido. O prazo final será confirmado quando o pedido for feito.",
    faqDefectiveItemQ: "Como lidar com item defeituoso?",
    faqDefectiveItemA:
      "Oferecemos UM ANO de garantia a partir da data de embarque. Durante o período de garantia, se houver um item defeituoso devido ao nosso material ou mão de obra, envie-nos os detalhes, incluindo descrição, foto ou vídeo, e até mesmo uma amostra defeituosa quando necessário. Nossos engenheiros irão analisar e fornecer uma solução. Se desejar devolver, entre em contato conosco e devolva os itens com a embalagem e acessórios originais. O valor será reembolsado quando os itens devolvidos forem recebidos ou um substituto gratuito será enviado.",
    faqWhyChooseUsQ: "Por que escolher a nossa empresa?",
    faqWhyChooseUsA:
      "Nossos produtos têm MOQ baixo e alta qualidade, capazes de atender aos padrões dos EUA ou da UE. Oferecemos alto nível de serviço, aceitamos pedidos OEM e Trade Assurance. Você pode embarcar sem preocupações.",

    companyImageSectionOverview: "Visão geral da empresa",
    companyImageSectionAdvantages: "Vantagens competitivas",
    companyImageSectionCustomization: "Capacidades de personalização",
    companyImageSectionExtended: "Perfil corporativo ampliado",
    companyImageSectionPackaging: "Especificações de embalagem e envio",
    companyImageSectionFactory: "Perfil da fábrica",
    companyImageSectionWorkflow: "Fluxo de produção",
    companyImageSectionTradeShow: "Participação em feiras",

    // --- order status / tab descriptions ---
    orderStatusPaid: "Pago",
    orderStatusPacked: "Embalado",
    orderStatusInTransit: "Em trânsito",
    orderStatusDelivered: "Entregue",
    orderStatusCancelled: "Cancelado",

    tabDescHome:
      "Gerencie as operações do seu espaço de trabalho e acompanhe o desempenho aqui.",
    tabDescStoreBase:
      "Configure os títulos da loja/admin e os metadados de SEO.",
    tabDescTemplateStudio: "Edite visualmente os módulos de layout da vitrine e salve modelos personalizados.",
    tabDescArticleManagement:
      "Gerencie artigos do blog em um espaço dedicado com edição por caixas de diálogo.",
    tabDescCompanyImages:
      "Gerencie ativos de imagem da empresa categorizados para o conteúdo do perfil da vitrine.",
    tabDescDesignNav:
      "Configure a navegação da vitrine e a estrutura de menus aninhados.",
    tabDescDesignCarousel:
      "Gerencie as imagens do carrossel para a seção principal da sua vitrine.",
    tabDescDesignBanner:
      "Configure mensagens de banner e conteúdo de chamada para ação.",
    tabDescFaqKnowledge:
      "Mantenha o conteúdo de FAQ usado pelas equipes de operações e vendas.",
    tabDescProducts:
      "Gerencie catálogo de produtos, detalhes e informações de preços.",
    tabDescProductCreate:
      "Crie um novo produto com detalhes completos e mídia.",
    tabDescMerchandising:
      "Avalie produtos candidatos, estrutura de preços e prontidão para lançamento.",
    tabDescProcurement:
      "Coordene planos de compra, progresso de fornecedores e prioridades de sourcing.",
    tabDescQuality:
      "Acompanhe pontos de inspeção e prontidão de liberação antes do atendimento.",
    tabDescLogistics:
      "Acompanhe o status do embarque, a prontidão da embalagem e a colaboração no rastreamento.",
    tabDescOrders:
      "Acompanhe o ciclo de vida do pedido, a execução e as atualizações de envio.",
    tabDescCustomers:
      "Gerencie os membros da sua equipe e as permissões de conta deles aqui.",
    tabDescMarketing:
      "Revise o status das campanhas e o desempenho de crescimento.",
    tabDescDiscounts:
      "Gerencie a estratégia de descontos e as regras promocionais.",
    tabDescFinance:
      "Monitore registros financeiros e tendências de receita.",
    tabDescFinanceIncome: "Revise cobranças de pedidos, receitas reconhecidas e lançamentos no livro de receitas.",
    tabDescFinanceExpenses: "Acompanhe faturas de compras, logística, marketing e despesas gerais.",
    tabDescFinanceReceivables: "Acompanhe contas a receber, envelhecimento e prioridades de cobrança.",
    tabDescFinancePayables: "Gerencie contas a pagar, pagamentos a fornecedores e urgências de vencimento.",
    tabDescFinanceInvoices: "Mantenha faturas, recibos e status de faturamento.",
    tabDescFinanceTax: "Revise ICMS/ISS a recolher, créditos de impostos e estimativas fiscais.",
    tabDescFinanceBudget: "Acompanhe orçamentos, alocação de gastos e alertas de estouro.",
    tabDescFinanceDaily: "Resuma receitas, despesas e fluxo de caixa líquido da empresa por dia.",
    tabDescFinanceMonthly: "Feche os livros mensais e revise lucros e variações orçamentárias.",
    tabDescFinanceYearly: "Revise receita anual, despesas, impostos e lucro líquido.",
    tabDescFinanceReconciliation: "Concilie contas a receber, cobranças, contas a pagar, faturas e situação fiscal.",
    tabDescFinanceApprovals: "Gerencie auditorias de aprovação de reembolsos, pagamentos e despesas.",
    tabDescFinanceReports: "Sintetize demonstrações financeiras, métricas operacionais e trabalhos de exportação.",
    tabDescAnalytics:
      "Analise insights de dados e métricas operacionais.",
    tabDescSettings:
      "Gerencie configurações de sistema de baixo nível, como conectividade com banco de dados.",
    tabDescWorkTargets:
      "Acompanhe e coordene metas diárias de trabalho.",
    tabDescWorkProcessing:
      "Lide com fluxos de trabalho atribuídos e registros de execução.",
    tabDescHrEmployee:
      "Visualize e mantenha perfis de funcionários e informações de conta.",
    tabDescHrRecruitment:
      "Acompanhe a fila de tarefas relacionadas a recrutamento e integração.",
    tabDescHrAttendance:
      "Monitore presença da equipe e status de atividade das contas.",
    tabDescHrOffice:
      "Gerencie cobertura de cargos e tarefas administrativas internas.",
    tabDescSiteMaintenance:
      "Mantenha o conteúdo da vitrine e a estabilidade do site.",
    tabDescPermissionMaintenance:
      "Mantenha permissões baseadas em funções e limites de acesso.",
    tabDescPositionMaintenance: "",
    tabDescProfile: "Revise as informações da sua conta.",
    tabDescPassword: "Altere a senha da sua conta com segurança.",
    tabDescInquiry:
      "Entre em contato com o vendedor e continue a comunicação da consulta.",
    tabDescWishlist:
      "Gerencie produtos salvos e itens preferidos de sourcing.",
    tabDescOrderProcessing:
      "Acompanhe e processe registros do ciclo de vida do pedido.",
    tabDescAfterSales:
      "Acompanhe solicitações de pós-venda e tickets de suporte.",

    // --- roles / menus ---
    roleDeveloper: "Desenvolvedor",
    roleSuperAdmin: "Super administrador",
    roleAdmin: "Administrador",
    roleCustomer: "Cliente",
    roleGuest: "Convidado",

    productCreateMenu: "Publicação de produto",
    productsMenu: "Gestão de produtos",
    merchandisingOverview: "Visão geral de merchandising",
    merchandisingCollection: "Pool coletado",
    internalOverview: "Visão geral e configuração",
    internalWorkspace: "Catálogo e atendimento",
    internalBusiness: "Vendas e clientes",
    internalOffice: "Espaço de trabalho por função",
    internalMaintenance: "Painel de manutenção",
    storefrontContent: "Conteúdo da vitrine",
    guestService: "Serviços para convidados",
    customerService: "Serviços ao cliente",
    commonAccount: "Minha conta",
    siteMaintenanceMenu: "Gestão de cargos",
    positionMaintenanceMenu: "Gestão de usuários",

    title: "Minha loja",
    home: "Visão geral operacional",
    storeDesign: "Configuração da loja",
    companyProfile: "Perfil da empresa",
    storeBase: "Configurações básicas da loja",
    templateStudio: "Estúdio de modelos",
    articleManagement: "Gestão de artigos",
    companyProfileMenu: "Introdução da empresa",
    companyImages: "Imagens da empresa",
    designNav: "Menu de navegação",
    designCarousel: "Carrossel da página inicial",
    designBanner: "Configurações de banner",
    faqKnowledge: "Base de conhecimento FAQ",
    products: "Gestão de produtos",
    productCreate: "Criar produto",
    merchandising: "Centro de merchandising",
    procurement: "Centro de compras",
    quality: "Centro de qualidade",
    logistics: "Colaboração logística",
    orders: "Consultas e pedidos",
    customers: "Gestão de clientes",
    marketing: "Campanhas",
    discounts: "Estratégia de preços",
    finance: "Visão financeira",
    financeIncome: "Livro de receitas",
    financeExpenses: "Faturas de despesas",
    financeReceivables: "Contas a receber",
    financePayables: "Contas a pagar",
    financeInvoices: "Gestão de faturas",
    financeTax: "Gestão fiscal",
    financeBudget: "Orçamento e gastos",
    financeDaily: "Faturas diárias",
    financeMonthly: "Fechamento mensal",
    financeYearly: "Demonstrações anuais",
    financeReconciliation: "Conciliação",
    financeApprovals: "Aprovações e auditoria",
    financeReports: "Relatórios e exportação",
    analytics: "Análise de dados",
    settings: "Configurações do sistema",

    menuCommon: "Comum",
    menuInternal: "Interno",
    menuWorkContent: "Conteúdo de trabalho",
    menuMaintenance: "Painel de manutenção",
    userManagementGroup: "Painel de manutenção",
    menuGuest: "Convidado",
    menuCustomer: "Cliente",

    workTargets: "Metas de tarefas",
    workProcessing: "Processamento de trabalho",
    hrEmployee: "Perfis de funcionários",
    hrRecruitment: "Recrutamento",
    hrAttendance: "Presença",
    hrOffice: "Administração do escritório",
    siteMaintenance: "Manutenção de cargos",
    permissionMaintenance: "Manutenção de permissões",
    positionMaintenance: "Gestão de usuários",
    profile: "Meu perfil",
    password: "Alterar senha",
    inquiry: "Mensagens de consulta",
    wishlist: "Lista de desejos",
    orderProcessing: "Processamento de pedidos",
    afterSales: "Serviço pós-venda",

    // --- profile / password / inquiry ---
    profileCardTitle: "Informações pessoais",
    accountId: "ID da conta",
    profileName: "Nome",
    profileEmail: "E-mail",
    profileRole: "Função",

    passwordCardTitle: "Atualizar senha da conta",
    currentPassword: "Senha atual",
    adminResetPasswordHint:
      "Esta ação redefine a senha do usuário-alvo. Não exige a senha atual dele.",
    newPassword: "Nova senha",
    confirmPassword: "Confirmar nova senha",
    savePassword: "Atualizar senha",
    passwordUpdated: "Senha atualizada com sucesso.",

    inquiryCardTitle: "Comunicação de consulta",
    inquiryCardBody:
      "Entre em contato com a equipe de vendas para discutir requisitos do produto, cotações e planos de entrega.",
    openInquiryCenter: "Abrir página de contato",
    openWhatsappChat: "Chat no WhatsApp",

    permissionSectionTitle: "Conjunto atual de permissões",
    permissionSectionBody:
      "As permissões são resolvidas a partir dos dados de login e mapeadas pela estrutura do seu cargo.",
    placeholderTodo:
      "Este módulo está habilitado para o seu cargo. Você pode expandir aqui as ações de negócio concretas.",

    // --- settings / system / base ---
    systemConfigTitle: "Centro de configurações do sistema",
    settingsTabDatabase: "Banco de dados",
    settingsTabDatabaseHint: "Configurações de conexão e pool",
    settingsTabEmail: "E-mail",
    settingsTabEmailHint: "Branding e modelos transacionais",

    mysqlHost: "Host do MySQL",
    mysqlPort: "Porta do MySQL",
    mysqlDatabase: "Banco de dados MySQL",
    mysqlUser: "Usuário MySQL",
    mysqlPassword: "Senha MySQL",
    mysqlPoolSize: "Tamanho do pool MySQL",
    mysqlConnectTimeoutMs: "Tempo limite de conexão MySQL (ms)",

    saveSystemConfig: "Salvar configurações do sistema",
    systemConfigSavedToast: "Configuração do sistema salva",
    systemConfigPathLabel: "Arquivo de configuração",
    restartRequiredHint:
      "Reinicie o backend após salvar para que as novas configurações de banco de dados entrem em vigor.",

    storefrontTitle: "Título da loja",
    adminTitle: "Título do painel administrativo",
    seoMetaTitle: "Título meta de SEO",
    seoDescription: "Descrição meta de SEO",
    seoKeywords: "Palavras-chave de SEO",
    seoCanonicalUrl: "URL canônica",
    seoRobots: "SEO robots",
    seoOgTitle: "Título Open Graph",
    seoOgDescription: "Descrição Open Graph",
    seoOgImage: "URL da imagem Open Graph",
    seoTwitterCard: "Tipo de cartão do Twitter",
    seoTwitterSite: "Conta/site do Twitter",

    saveBaseSettings: "Salvar configurações básicas",
    baseSavedToast: "Configurações básicas salvas",

    // --- common ui ---
    hello: "Olá, vamos começar.",
    askAnything: "Pergunte qualquer coisa...",
    supportLine: "Precisa de ajuda? Fale com o suporte",

    addStoreName: "Adicionar nome da loja",
    firstProduct: "Adicione seu primeiro produto",
    firstProductDesc:
      "Comece adicionando um produto e detalhes principais para prepará-lo para vendas.",
    addProduct: "Adicionar produto",
    importData: "Importar",

    customizeStore: "Personalize sua loja online",
    customizeStoreDesc:
      "Escolha um modelo e depois adicione seu logotipo, cores e imagens.",
    customTemplate: "Modelo personalizado",
    payments: "Configurar pagamentos",
    shipping: "Verificar tarifas de envio",
    domain: "Domínio personalizado",

    quickSales: "Simplifique vendas multicanal",
    quickSalesDesc:
      "Gerencie seus anúncios em vários marketplaces a partir de um só lugar.",

    storeSettings: "Configurações da loja",
    general: "Geral",
    billing: "Faturamento",
    usersPermissions: "Usuários",

    paginationPrevious: "Anterior",
    paginationNext: "Próximo",
    paginationPage: "Página",
    paginationTotal: "Total",

    policies: "Políticas",
    businessInfo: "Detalhes do negócio",
    contactInfo: "Contato da loja",
    defaults: "Padrões da loja",

    businessMode: "Modo de negócio",
    b2b: "B2B",
    b2c: "B2C",
    modeSaved: "Modo da loja atualizado",
    modeSavedToast: "Modo de negócio alterado com sucesso",

    navSettings: "Menu de navegação",
    navLabel: "Nome do submenu",
    navPath: "Link do submenu",
    addSubmenu: "Adicionar submenu",
    saveNavigation: "Salvar lista de submenus",
    navSavedToast: "Menu de navegação salvo",

    bannerSettings: "Lista do carrossel",
    bannerTitle: "Título do banner",
    bannerAnnotation: "Anotação da imagem",
    bannerButtonText: "Nome do botão",
    bannerButtonLink: "Link do botão",
    bannerImageUrl: "URL da imagem do banner",
    addBanner: "Adicionar banner",
    removeBanner: "Remover",
    saveBanners: "Salvar lista do carrossel",
    bannersSavedToast: "Lista do carrossel salva",

    saveFaqKnowledge: "Salvar base de conhecimento FAQ",
    faqKnowledgeSavedToast: "Base de conhecimento FAQ salva",
    saveCompanyImages: "Salvar imagens da empresa",
    companyImagesSavedToast:
      "Configuração das imagens da empresa salva",

    companyIntroductionTitle: "Introdução da empresa",
    companyIntroductionHint:
      "Descreva o perfil da sua empresa, seus pontos fortes e capacidades de serviço.",
    companyIntroductionPlaceholder:
      "Digite o conteúdo de apresentação da empresa...",
    addImageUrl: "Adicionar URL de imagem",
    uploadLocalImages: "Enviar imagens locais",
    addFaq: "Adicionar FAQ",
    saveCarouselImages: "Salvar imagens do carrossel",
    carouselImagesSavedToast: "Imagens do carrossel salvas",

    close: "Fechar",
    save: "Salvar",
    create: "Criar",
    search: "Pesquisar na aba atual",
    refresh: "Atualizar",
    createProduct: "Criar produto",
    cancel: "Cancelar",
    edit: "Editar",
    remove: "Excluir",

    systemSnapshot: "Instantâneo do sistema",
    activeSearch: "Pesquisa na aba ativa",
    none: "(nenhum)",
    orderRecords: "Registros de pedidos",
    userRecords: "Registros de usuários",
    lastRefresh: "Última atualização",
    productsCount: "Produtos",
    customersCount: "Clientes",
    ordersCount: "Pedidos",
    revenue: "Receita USD",

    localeLabel: "Idioma",
    sku: "SKU",
    name: "Nome",
    description: "Descrição",
    price: "Preço USD",
    imageUrl: "URL da imagem",
    category: "Categoria",
    model: "Modelo",
    titleField: "Título do produto",
    detailVideo: "URL do vídeo detalhado",
    mainImages: "Imagens principais (6 URLs, uma por linha)",
    detailImages: "Imagens detalhadas (URLs, uma por linha)",
    parameters: "Parâmetros (uma por linha: chave:valor)",
    openCreateProduct: "Abrir formulário de detalhes do produto",

    id: "ID",
    serialNumber: "Nº",
    userId: "ID do usuário",
    actions: "Ações",
    email: "E-mail",
    role: "Função",
    username: "Nome de usuário",
    nickname: "Apelido",
    userRole: "Função do usuário",
    phone: "Número de telefone",
    accountStatus: "Status da conta",
    jobTitle: "Cargo",
    registeredAt: "Registrado em",
    lastActiveAt: "Última atividade em",
    statusActive: "Ativo",
    statusDisactive: "Inativo",
    permissions: "Permissões",
    position: "Cargo",
    accessSummary: "Acesso",
    positionName: "Nome do cargo",
    positionKey: "Chave do cargo",
    department: "Departamento",
    addPosition: "Adicionar cargo",
    permissionName: "Nome da permissão",
    permissionKey: "Chave da permissão",
    addPermission: "Adicionar permissão",
    editPermissions: "Editar permissões",
    permissionSelectTitle: "Selecionar permissões",
    permissionSelectedSummary: "Permissões selecionadas",
    permissionQuickSearchPlaceholder:
      "Pesquisa rápida por chave ou anotação",
    defaultAdminPosition: "Administrador de operações",

    orderId: "Pedido",
    total: "Total",
    status: "Status",
    cartItems: "Itens do carrinho",
    logout: "Sair",
    changePasswordAction: "Alterar senha",
    userPasswordModalTitle: "Redefinir senha do usuário",
    userPasswordUpdated: "Senha do usuário atualizada com sucesso.",
    targetUser: "Usuário-alvo",
    userDataResyncedHint:
      "Os campos do perfil foram sincronizados novamente com o servidor após salvar.",
    userManagementRestrictedHint:
      "É necessário um nível mais alto de permissão para esta operação.",

    capability: {
      ...((en.admin && en.admin.capability) || {}),

      "admin:overview:read": "Ver visão geral da administração",
      "admin:products:read": "Ver produtos da administração",
      "admin:products:write": "Editar produtos da administração",
      "admin:orders:read": "Ver pedidos da administração",
      "admin:orders:write": "Editar pedidos da administração",
      "admin:users:read": "Ver usuários da administração",
      "admin:users:role:write": "Editar funções de usuário",
      "admin:users:position:assign": "Atribuir cargos aos usuários",
      "admin:storefront:read": "Ver configurações da vitrine",
      "admin:storefront:write": "Editar configurações da vitrine",
      "admin:system-config:read": "Ver configuração do sistema",
      "admin:system-config:write": "Editar configuração do sistema",
      "shop:profile:read": "Ver perfil da loja",
      "shop:password:write": "Atualizar senha da loja",
      "shop:orders:read": "Ver pedidos da loja",
      "shop:inquiry:write": "Gerenciar consultas da loja",
      "shop:wishlist:read": "Ver lista de desejos",
      "shop:orders:processing:read": "Ver processamento de pedidos",
      "shop:after-sales:read": "Ver pós-venda",
      "internal:work:targets:read": "Ver metas de trabalho",
      "internal:work:processing:read": "Ver processamento de trabalho",
      "internal:maintenance:site:write": "Editar manutenção do site",
      "internal:maintenance:permission:write":
        "Editar manutenção de permissões",
      "internal:maintenance:position:write":
        "Editar manutenção de cargos",
      "shop:products:read": "Ver produtos da loja",
      "shop:storefront:read": "Ver vitrine",
      "internal:system:config:read":
        "Ver configuração interna do sistema",
      "internal:system:config:write":
        "Editar configuração interna do sistema",
      "internal:security:audit:read": "Ver auditorias de segurança",
      "internal:security:session:revoke": "Revogar sessões",
      "internal:integration:manage": "Gerenciar integrações",
      "admin:users:write": "Editar usuários da administração",
      "admin:users:password:reset":
        "Redefinir senhas de usuários",
      "admin:users:delete": "Excluir usuários da administração",
      "crm:customer:read": "Ver registros de clientes",
      "crm:customer:write": "Editar registros de clientes",
      "crm:customer:assign": "Atribuir clientes",
      "website:content:read": "Ver conteúdo do site",
      "website:content:write": "Editar conteúdo do site",
      "website:navigation:write": "Editar navegação do site",
      "website:banner:write": "Editar banners do site",
      "website:seo:write": "Editar configurações de SEO",
      "website:theme:write": "Editar tema do site",
      "website:publish": "Publicar conteúdo do site",
      "admin:products:create": "Criar produtos da administração",
      "admin:products:delete": "Excluir produtos da administração",
      "merchandising:selection:read": "Ver seleção de merchandising",
      "merchandising:selection:write":
        "Editar seleção de merchandising",
      "catalog:pricing:write": "Editar preços do catálogo",
      "catalog:inventory:write": "Editar inventário",
      "catalog:translation:write": "Editar traduções do catálogo",
      "sales:inquiry:read": "Ver consultas de vendas",
      "sales:inquiry:reply": "Responder consultas de vendas",
      "sales:quotation:create": "Criar cotações",
      "sales:quotation:approve": "Aprovar cotações",
      "sales:contract:write": "Editar contratos de vendas",
      "sales:sample:manage": "Gerenciar amostras",
      "order:status:update": "Atualizar status do pedido",
      "order:split:merge": "Dividir ou mesclar pedidos",
      "procurement:purchase:write": "Editar ordens de compra",
      "production:plan:write": "Editar planos de produção",
      "qa:inspection:write": "Editar inspeções de qualidade",
      "logistics:shipment:write": "Editar registros de embarque",
      "logistics:tracking:read": "Ver rastreamento de embarques",
      "trade:customs:doc:write": "Editar documentos aduaneiros",
      "finance:invoice:read": "Ver faturas",
      "finance:invoice:write": "Editar faturas",
      "finance:payment:read": "Ver pagamentos",
      "finance:payment:write": "Editar pagamentos",
      "finance:refund:approve": "Aprovar reembolsos",
      "finance:reconciliation:write":
        "Editar registros de reconciliação",
      "finance:tax:write": "Editar configurações fiscais",
      "marketing:campaign:read": "Ver campanhas de marketing",
      "marketing:campaign:write": "Editar campanhas de marketing",
      "marketing:coupon:write": "Editar cupons",
      "marketing:lead:export": "Exportar leads",
      "analytics:dashboard:read": "Ver painel analítico",
      "analytics:report:export": "Exportar relatórios analíticos",
      "support:ticket:read": "Ver tickets de suporte",
      "support:ticket:write": "Editar tickets de suporte",
      "support:return:approve": "Aprovar devoluções",
      "support:complaint:handle": "Tratar reclamações",
      "office:announcement:write": "Publicar anúncios",
      "office:document:read": "Ver documentos do escritório",
      "office:document:write": "Editar documentos do escritório",
      "office:workflow:approve": "Aprovar fluxos de trabalho do escritório",
      "office:meeting:manage": "Gerenciar reuniões",
      "hr:employee:read": "Ver perfis de funcionários",
      "hr:employee:write": "Editar perfis de funcionários"
    }
  },
  blogReadingTimeMin: "min de leitura",
  blogShowLess: "Mostrar menos",
  requestFreeSample: "Solicitar amostra gratis",
  factoryStatsSince: "Desde 1995",
  factoryStatsCapacity: "Mais de 10.000 unidades por mes",
  factoryStatsExport: "Exportacao para mais de 50 paises",
  factoryStatsCert: "Certificada ISO 9001 e BSCI",
  aboutAddress: "Endereco: Edificio Ruihe Kechuang, Wanglong Road, Distrito de Yuelu, Changsha, Hunan, China",
  aboutTeamTitle: "Equipe dinamica e profissional",
  aboutTeamBody: "Somos uma equipe jovem e experiente, com entendimento profundo das demandas do mercado e dos detalhes tecnicos da industria de yoga. Com selecao rigorosa e resposta eficiente, garantimos que cada entrega atenda altos padroes comerciais.",
  aboutCustomizationTitle: "Servicos completos de personalizacao",
  aboutCustomizationBody: "Da impressao de logotipo e design de embalagem ao desenvolvimento de moldes funcionais, oferecemos solucoes de personalizacao flexiveis e profundas para ajudar sua marca a se destacar no mercado.",
  aboutFactoryPartnerTitle: "Parceiros fabris premium",
  aboutFactoryPartnerBody: "Trabalhamos em estreita colaboracao com bases de fabricacao certificadas ISO/BSCI, controlando a qualidade desde a origem para garantir estabilidade de producao e entrega pontual.",
  oemServiceShowcaseAria: "Servicos de personalizacao OEM e ODM",
  oemServiceShowcaseTitle: "Servicos de personalizacao OEM e ODM",
  oemServiceShowcaseBody: "Suporte flexivel de ponta a ponta, da revisao do conceito ate a producao e entrega.",
  oemCompareHeadBody: "Quatro caminhos comuns, comparando versao base e resultado personalizado.",
  oemCompareBaseSuffix: "versao base",
  oemCompareOptionsSuffix: "opcoes de personalizacao",
  oemCompareCustomizedSuffix: "versao personalizada",
  oemCompare1Title: "Aplicacao de logotipo",
  oemCompare1Body: "De produto simples para apresentacao de marca.",
  oemCompare1BeforeLabel: "Base",
  oemCompare1AfterLabel: "Com logotipo",
  oemCompare1CustomizationLabel: "Adicao de logotipo",
  oemCompare1Item1: "Impressao",
  oemCompare1Item2: "Relevo",
  oemCompare1Item3: "Marcacao a laser",
  oemCompare2Title: "Cor e acabamento",
  oemCompare2Body: "De especificacao neutra para cor adaptada ao mercado.",
  oemCompare2BeforeLabel: "Padrao",
  oemCompare2AfterLabel: "Cor personalizada",
  oemCompare2CustomizationLabel: "Atualizacao de cor",
  oemCompare2Item1: "Cor",
  oemCompare2Item2: "Textura",
  oemCompare2Item3: "Tamanho",
  oemCompare3Title: "Configuracao de embalagem",
  oemCompare3Body: "De embalagem simples para apresentacao pronta para venda no varejo.",
  oemCompare3BeforeLabel: "Embalagem simples",
  oemCompare3AfterLabel: "Pronta para varejo",
  oemCompare3CustomizationLabel: "Detalhes da embalagem",
  oemCompare3Item1: "Cartao interno",
  oemCompare3Item2: "Codigo de barras",
  oemCompare3Item3: "Marcacao da caixa",
  oemCompare4Title: "Desenvolvimento de combinacoes",
  oemCompare4Body: "De itens avulsos para conjunto pronto para canal.",
  oemCompare4BeforeLabel: "Itens avulsos",
  oemCompare4AfterLabel: "Conjunto combinado",
  oemCompare4CustomizationLabel: "Logica de combinacao",
  oemCompare4Item1: "Kit para estudio",
  oemCompare4Item2: "Pacote para Amazon",
  oemCompare4Item3: "Mix promocional",
  oemCasesTitle: "Casos de personalizacao",
  oemCase1Title: "Linha inicial para estudio boutique",
  oemCase1Summary: "Apresentacao de kit inicial para lancamento de estudio boutique.",
  oemCase1Details: "Kit com logotipo aprovado em 12 dias.",
  oemCase2Title: "Atualizacao de marca propria para varejo",
  oemCase2Summary: "Visual de embalagem atualizado para uma apresentacao mais limpa na prateleira.",
  oemCase2Details: "Aprovacao mais rapida do comprador e maior consistencia no varejo.",
  oemCase3Title: "Pacote fitness pronto para marketplace",
  oemCase3Summary: "Configuracao de pacote preparada para e-commerce e listagem.",
  oemCase3Details: "Inserto, codigo de barras e revisao para producao em massa prontos.",
  oemOrderingFlowKicker: "Fluxo de pedido",
  oemOrderingFlowTitle: "Contato e pedido em cinco etapas",
  oemContactFlow1: "Consulta inicial com lista de produtos, mercado de destino e solicitacao de marca.",
  oemContactFlow2: "Cotacao com plano de amostras, prazo de entrega e opcoes de embalagem.",
  oemContactFlow3: "Confirmacao da amostra e aprovacao dos detalhes do pedido.",
  oemContactFlow4: "Deposito, producao, inspecao e agendamento de embarque.",
  oemContactFlow5: "Pagamento do saldo, documentos de exportacao e acompanhamento pos-venda.",
  oemContactSideTitle: "Pronto para discutir seu pedido OEM?",
  oemContactSideBody: "Envie seu logotipo, quantidade alvo e ideia de embalagem. Responderemos com uma rota pratica de cotacao e recomendacao de amostras.",
  oemContactSideNote: "Canal de primeiro contato recomendado: email ou formulario de consulta com arte e janela de embarque alvo.",
  oemContactSideCta: "Falar com o time comercial",
  requestQuote: "Solicitar cotacao",
  trustTitle: "Parceiros globais e confianca",
  factoryStatsSize: "Fabrica de 30.000 m2",
  factoryStatsQC: "100% controle de qualidade em linha e final",
  homeAriaTrust: "Confianca e parceiros",
  homeAriaStats: "Dados e capacidade da fabrica",
};
